module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Treść",
      "required": "",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb562fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/HTMLWidget.vue
// module id = 801
// module chunks = 0